module.exports = __webpack_public_path__ + "img/highlighting-white.f9adf5ca.svg";